import {
  withTranslation,
} from 'react-i18next';

import ClockDialogView from './ClockDialogView';

const TranslatedComponent = withTranslation()(ClockDialogView);

const Component = TranslatedComponent;

export default Component;
